import { render, staticRenderFns } from "./telSetting.vue?vue&type=template&id=ddb0ba36&scoped=true&"
import script from "./telSetting.vue?vue&type=script&lang=js&"
export * from "./telSetting.vue?vue&type=script&lang=js&"
import style0 from "./telSetting.vue?vue&type=style&index=0&id=ddb0ba36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb0ba36",
  null
  
)

export default component.exports